import { GlobalFilterVesselMetaData, VesselInfo } from "../../../src/models/types/vessels-model.types";
import { IMOsCurrentScheduleState } from "../../../src/models/types/voyage-schedules-model.types";

export enum FilterType {
    Service = 'sc',
    Type = 'type',
    Operator = 'op',
    Location = 'loc',
    VesselClass = 'vc',
    FleetGroups = 'fg',
    Alarms = 'al',
    Version = "vs",
    AisStatus = "ais",
    PlansMonitoring = "pm",
    WeatherAlarms = "wa",
    TimeCriticality = "tc",
    RouteType = "rt",
    ImoGrouping = "ig"
}

export enum OperatorId {
    MSK = "MSK",
    MCC = "MCC",
    SEA = "SEA",
    SGL = "SGL",
    MLL = "MLL",
    ALI = "ALI",
    EXT = "EXT",
    NonMSKWithBox = "NonMSKWithBox",
    UNWN = "unwn",
    NonMSK = "nonMSK",
    MSKUWN = "MskUnwn"
}

export enum LocationId {
    ONVOYAGE = "on-voyage",
    INPORT = "in-port"
}

export enum VesselVoyageVersion {
    Premium = "premium",
    Basic = "basic",
    Cloud = "cloud",
    Blank = "blank"
}

export enum AisStatusId {
    UnderWayUsingEngine = "uwue",
    AtAnchor = "anchor",
    Moored = "moored",
    NotUnderCommand = "ntundrcmnd",
    Aground = "aground",
    ConstrainedByHerDraught = "constdraught",
    RestrictedManoeuvrability = "resman",
    Undefined = "undefined",
    Other = "otr"
} 

export enum WeatherAlarms {
    HeavyWeatherAlarm = "heavyweather",
    ParametricRoll = "parametricroll"
} 

export type VoyageFilterResult = {
    cmd?: string;
    not?: boolean;
    vals?: string[];
}

export type VoyageFilterType = {
    commands: VoyageFilterResult[];
    text?: string[];
}

export interface WizardStructureInterface {
    id: string;
    name: string;
    items?: WizardStructureItem[];
    opened?: boolean,
    onlyForInternal?: boolean
}

export interface WizardStructureItem {
    id: string;
    name: string;
    items?: WizardStructureItem[]
}

export enum PaginationDirection {
    LEFT = "left",
    RIGHT = "right"
}

export interface GlobalFilterDataItem {
    omniFilter: VoyageFilterType,
    showNonMaersk: boolean,
    maerskVesselsWithImo: GlobalFilterVesselMetaData[],
    nonMaerskVesselsWithImo: GlobalFilterVesselMetaData[],
    scheduleStates: IMOsCurrentScheduleState[]
}

export const IMO_TO_HIDE = 9632082; 
